export const STATUS_CATEGORIES = "categories";
export const STATUS_SHOPS = "shops";
// payment types
export const STATUS_MOBILE_MONEY = 2;
export const STATUS_CASH_ON_DELIVERY = 1;
export const PAID = 1;
export const NOT_PAID = 0;
// feed Types
export const PRODUCT_SECTION = 1;
export const BANNER_VIEW = 100;
export const CATEGORY_VIEW = 3;
// status types
export const PENDING = 0;
export const CONFIRMED = 1;
export const IN_PROGRESS = 2;
export const DELIVERED = 3;
export const CANCELLED = 4;
// ticket status types
export const STATUS_RESOLVED = 2;

// STOCK TYPES
export const IN_STOCK = 1;
export const VARIABLE_STOCK = 2;
export const OUT_OF_STOCK = 3;

// MISC
export const APP_NAME = "Eight-8";
export const APP_TAGLINE = "You want it, you got it!";
export const DEFAULT_LIMIT = 10;
export const CONFIG = "config";
export const CART_REMINDER = "cart_reminder";

// USER STATUS
export const STATUS_STAFF = "staff";

// SOURCES
export const TICKETS = "tickets";
export const PAYMENTS = "payments";
export const VERSION = "version";
export const TEMPLATES = "templates";
export const FEED = "feed";
export const REGIONS = "regions";

// FORM FIELD TYPES
export const SELECT_TYPE = "select";
export const SWITCH_TYPE = "switch";
export const TEXT_TYPE = "text";
export const COMPONENT_TYPE = "component";
export const FILE_TYPE = "file";
export const TEXT_VIEW_TYPE = "text_view";
export const HEADING_TYPE = "heading";

// STATUSES
export const SUCCESSFUL = "successful";

// PERMISSIONS
export const CAN_ADMIN = "can_admin";
export const CAN_ORDERS = "can_orders";
export const CAN_PAYMENTS = "can_payments";
export const CAN_SHOPS = "can_shops";
export const CAN_PRODUCTS = "can_products";
export const CAN_CATEGORIES = "can_categories";
export const CAN_CONFIG = "can_config";
export const CAN_USERS = "can_users";
export const CAN_SUPPORT = "can_support";

export const APK_DOWNLOAD_URL =
  "https://storage.cloud.google.com/eight-8-ug.appspot.com/apk/Eight.8.v.1.0.5.apk";
export const PLAYSTORE_URL =
  "https://play.google.com/store/apps/details?id=com.matt.eightto8";
